import { BaseDto } from '../../base/dtos/base.dto';

import { AreaDto } from './area.dto';

/**
 * Country DTO
 */
export class CountryDto extends BaseDto {
	/**
	 * Country UUID
	 */
	uuid!: string;

	/**
	 * Country name
	 */
	name!: string;

	/**
	 * ISO 3166-1 alpha-2 country code
	 */
	isoCode!: string;

	/**
	 * Flag indicating whether this country is in use
	 */
	isVisible!: boolean;

	/**
	 * Flag indicating whether this country is a market where business is conducted
	 */
	isMarket!: boolean;

	/**
	 * Areas within the country
	 */
	areas?: AreaDto[];
}
